import { render, staticRenderFns } from "./MandateStep4.vue?vue&type=template&id=6b045b9a&scoped=true&"
import script from "./MandateStep4.vue?vue&type=script&lang=js&"
export * from "./MandateStep4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b045b9a",
  null
  
)

export default component.exports